import React from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./TermsandConditions.css"; // optional extra styling
import JobSeekerNavbar from "../Pages/Navbar/Navbar";
import EmployerNavbar from "../Pages/Navbar/EmployerNavbar";
import EmployeeNavbar from "../Pages/Navbar/JobSeekerNavbar";
import AgencyNavbar from "../Pages/Navbar/AgencyNavbar";
import AdminNavbar from "../Pages/Navbar/AdminNavbar";
import Footer from "../Footer/Footer"

const user = JSON.parse(localStorage.getItem("user")) || {};

// Determine which Navbar to show
const renderNavbar = () => {
  if (user.user_type === "employer") {
    return <EmployerNavbar />;
  } else if (user.user_type === "job seeker") {
    return <EmployeeNavbar />;
  } else if (user.user_type === "agency") {
    return <AgencyNavbar />;
  } else if (user.user_type === "admin") {
    return <AdminNavbar />;
  } else {
    return <JobSeekerNavbar />;
  }
};

function TermsandConditions() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  return (
    <>
      {renderNavbar()}
      <div className="terms-section py-5 mt-5">
        <Container>
          {isArabic ? (
            <>
              <h1 className="mb-4 text-center fw-bold">
                الشروط والأحكام –{" "}
                <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                  Gulfworker.net
                </a>
              </h1>

              <p>
                مرحباً بكم في{" "}
                <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                  Gulfworker.net
                </a>{" "}
                ("الموقع الإلكتروني" أو "البوابة" أو "نحن"). من خلال الوصول إلى خدماتنا أو استخدامها، فإنك ("المستخدم" أو "الباحث عن عمل" أو "صاحب العمل" أو "مكتب الاستقدام") توافق على الالتزام بشروط وأحكام الاستخدام هذه والتقيد بها. إذا كنت لا توافق عليها، يرجى عدم استخدام موقعنا الإلكتروني.
              </p>

              <div className="mt-4">
                <h4>1. الأهلية</h4>
                <ul>
                  <li>يجب أن لا يقل عمر المستخدمين عن 18 عاماً للتسجيل أو التقديم على الوظائف.</li>
                  <li>
                    من خلال إنشاء حساب، فإنك تؤكد أن جميع المعلومات المقدمة صحيحة ودقيقة وغير مضللة.
                  </li>
                </ul>

                <h4>2. طبيعة الخدمة</h4>
                <ul>
                  <li>
                    <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                      Gulfworker.net
                    </a>{" "}
                    هو بوابة وظائف عبر الإنترنت تربط بين الباحثين عن عمل وأصحاب العمل ومكاتب الاستقدام.
                  </li>
                  <li>يجوز للباحثين عن عمل تحميل ملفاتهم الشخصية وسيرهم الذاتية وتفاصيل الاتصال الخاصة بهم.</li>
                  <li>
                    يجوز لأصحاب العمل ومكاتب الاستقدام نشر الشواغر الوظيفية وشراء الاشتراكات لتمييز أو إبراز إعلانات الوظائف لزيادة ظهورها.
                  </li>
                  <li>
                    قد يتم عرض تفاصيل الاتصال الخاصة بالباحثين عن عمل وأصحاب العمل ومكاتب الاستقدام علناً وتكون مرئية لجميع الزوار والمستخدمين المسجلين لأغراض التوظيف.
                  </li>
                </ul>

                <h4>3. مسؤوليات المستخدم</h4>
                <ul>
                  <li>يجب على الباحثين عن عمل ضمان دقة واكتمال سيرهم الذاتية وملفاتهم الشخصية.</li>
                  <li>
                    يجب على أصحاب العمل ومكاتب الاستقدام التأكد من أن الوظائف المنشورة حقيقية ودقيقة وقانونية.
                  </li>
                  <li>
                    يجب على المستخدمين عدم تحميل أو إرسال محتوى غير قانوني أو احتيالي أو مسيء أو مضلل.
                  </li>
                </ul>

                <h4>4. الدفع والاشتراك</h4>
                <h6>رسوم الاشتراك</h6>
                <ul>
                  <li>
                    الخدمات مثل إعلانات الوظائف المميزة وحزم الاشتراك تكون مدفوعة الأجر لأصحاب العمل ومكاتب الاستقدام.
                  </li>
                  <li>
                    يجب دفع جميع رسوم الاشتراك مقدماً وهي غير قابلة للاسترداد نهائياً، باستثناء ما يقتضيه القانون.
                  </li>
                  <li>
                    يتم دفع الرسوم فقط بغرض نشر إعلانات الوظائف على{" "}
                    <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                      Gulfworker.net
                    </a>
                    .
                  </li>
                </ul>

                <h6>لا ضمان</h6>
                <p>
                  شراء اشتراك أو تمييز إعلان وظيفة لا يضمن تلقي طلبات أو ردود أو مقابلات أو توظيفاً ناجحاً.
                </p>
                <p>
                  لا يضمن موقع{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  ما يلي:
                </p>
                <ul>
                  <li>دقة أو مؤهلات أو موثوقية الباحثين عن عمل أو أصحاب العمل.</li>
                  <li>ملاءمة أي مرشح لمنصب أو أي صاحب عمل لباحث عن عمل.</li>
                </ul>

                <h6>حدود النزاع</h6>
                <p>
                  في حالة حدوث أي نزاع أو شكوى أو مشكلة قانونية - بما في ذلك النزاعات التي يثيرها أطراف ثالثة أو محامون أو أشخاص ذوو نوايا سيئة - فإن الحد الأقصى للمسؤولية القانونية لـ{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  يقتصر بشكل صارم على رسوم الاشتراك المدفوعة فعلياً من قبل صاحب العمل أو مكتب الاستقدام المعني.
                </p>
                <p>
                  لن يتم قبول أي مطالبات بالتعويض عن الأضرار أو الخسائر التجارية أو أي تكاليف تبعية.
                </p>

                <h6>التعويض</h6>
                <p>
                  باستخدام{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>
                  ، يوافق أصحاب العمل ومكاتب الاستقدام والباحثون عن عمل على تعويض وإبراء ذمة{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  ومديريها وموظفيها وشركائها من أي وجميع المطالبات أو المطالب أو المسؤوليات أو الأضرار أو النفقات (بما في ذلك الرسوم القانونية) الناشئة عن:
                </p>
                <ul>
                  <li>استخدامهم للمنصة؛</li>
                  <li>اتفاقياتهم وتفاعلاتهم مع بعضهم البعض؛ أو</li>
                  <li>أي معلومات خاطئة أو مضللة أو ضارة يقدمونها.</li>
                </ul>

                <h6>حدود المسؤولية</h6>
                <p>
                  لا يتحمل موقع{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  المسؤولية بأي حال من الأحوال عن:
                </p>
                <ul>
                  <li>أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية.</li>
                  <li>خسارة الأرباح أو الفرص أو السمعة.</li>
                  <li>
                    المطالبات التي تتجاوز رسوم الاشتراك التي استلمتها بالفعل{" "}
                    <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                      Gulfworker.net
                    </a>
                    .
                  </li>
                </ul>

                <h4>5. لا ضمان للتوظيف</h4>
                <p>
                  موقع{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  هو منصة فقط ولا يعمل كوكالة توظيف ولا تضمن التعيين في الوظائف.
                </p>
                <p>تحميل السيرة الذاتية أو التقديم على وظيفة لا يضمن التوظيف.</p>
                <p>
                  قرارات التوظيف تقع بالكامل بين الباحثين عن عمل وأصحاب العمل ومكاتب الاستقدام.
                </p>

                <h4>6. العرض العام للمعلومات</h4>
                <ul>
                  <li>
                    من خلال التسجيل، يوافق المستخدمون على أن تفاصيل الاتصال الخاصة بهم (السير الذاتية، رسائل البريد الإلكتروني، أرقام الهواتف، معلومات الشركة/الوكالة) قد تكون مرئية للعامة.
                  </li>
                  <li>
                    موقع{" "}
                    <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                      Gulfworker.net
                    </a>{" "}
                    غير مسؤول عن كيفية استخدام الأطراف الثالثة للمعلومات المعروضة علناً.
                  </li>
                  <li>يجب على المستخدمين مشاركة المعلومات التي يشعرون بالارتياح لجعلها عامة فقط.</li>
                </ul>

                <h4>7. الملكية الفكرية</h4>
                <p>
                  جميع المحتويات الموجودة على موقع{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  (الشعارات، النصوص، الرسومات، التصميم) مملوكة لـ{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  ولا يجوز نسخها أو إعادة إنتاجها أو توزيعها دون موافقة كتابية مسبقة.
                </p>

                <h4>8. إنهاء الحسابات</h4>
                <p>
                  موقع{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  يحتفظ بالحق في تعليق أو إنهاء الحسابات التي تنتهك هذه الشروط أو تشارك في نشاط احتيالي أو غير قانوني أو مضلل، دون إشعار مسبق.
                </p>

                <h4>9. التعديلات</h4>
                <p>
                  يجوز لموقع{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  تحديث أو تعديل هذه الشروط والأحكام في أي وقت. وتصبح التحديثات سارية المفعول بمجرد نشرها على الموقع الإلكتروني. ويعتبر الاستخدام المستمر للموقع قبولاً للشروط المحدثة.
                </p>

                <h4>10. القانون الحاكم</h4>
                <p>
                  تخضع هذه الشروط وتُفسر وفقاً لقوانين [الاختصاص القضائي المعمول به، على سبيل المثال، الهند / الإمارات العربية المتحدة].
                </p>
                <p>
                  وتخضع أي نزاعات تنشأ بموجب هذه الشروط للاختصاص القضائي الحصري للمحاكم في [مومباي / الهند].
                </p>

                <h4>11. اتصل بنا</h4>
                <p>
                  للأسئلة أو الاستفسارات أو الشكاوى المتعلقة بهذه الشروط، يرجى الاتصال على: <br />
                  📧 البريد الإلكتروني:{" "}
                  <a href="mailto:support@gulfworker.net">support@gulfworker.net</a>
                </p>
              </div>
            </>
          ) : (
            <>
              <h1 className="mb-4 text-center fw-bold">
                Terms & Conditions –{" "}
                <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                  Gulfworker.net
                </a>
              </h1>

              {/* <p className="text-muted text-center">Effective Date: [Insert Date]</p>
              <p className="text-muted text-center">Last Updated: [Insert Date]</p> */}

              <p>
                Welcome to{" "}
                <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                  Gulfworker.net
                </a>{" "}
                (“Website,” “Portal,” “We,” or “Us”). By accessing or using our
                services, you (“User,” “Jobseeker,” “Employer,” or “Manpower Agency”)
                agree to comply with and be bound by these Terms & Conditions. If you
                do not agree, please do not use our Website.
              </p>

              <div className="mt-4">
                <h4>1. Eligibility</h4>
                <ul>
                  <li>Users must be at least 18 years old to register or apply for jobs.</li>
                  <li>
                    By creating an account, you confirm that all information provided
                    is true, accurate, and not misleading.
                  </li>
                </ul>

                <h4>2. Nature of Service</h4>
                <ul>
                  <li>
                    <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                      Gulfworker.net
                    </a>{" "}
                    is an online job portal connecting Jobseekers, Employers, and
                    Manpower Agencies.
                  </li>
                  <li>Jobseekers may upload profiles, CVs, and contact details.</li>
                  <li>
                    Employers and Manpower Agencies may post job vacancies and may
                    purchase subscriptions to highlight or feature job postings for
                    better visibility.
                  </li>
                  <li>
                    Contact details of Jobseekers, Employers, and Manpower Agencies
                    may be publicly displayed and visible to all visitors and
                    registered users for recruitment purposes.
                  </li>
                </ul>

                <h4>3. User Responsibilities</h4>
                <ul>
                  <li>Jobseekers must ensure the accuracy and completeness of their CVs and profiles.</li>
                  <li>
                    Employers and Manpower Agencies must ensure that job postings are
                    genuine, accurate, and lawful.
                  </li>
                  <li>
                    Users must not upload or transmit unlawful, fraudulent, offensive,
                    or misleading content.
                  </li>
                </ul>

                <h4>4. Payment & Subscription</h4>
                <h6>Subscription Fees</h6>
                <ul>
                  <li>
                    Services such as featured job postings and subscription packages
                    are chargeable for Employers and Manpower Agencies.
                  </li>
                  <li>
                    All subscription fees must be paid in advance and are strictly
                    non-refundable, except where required by law.
                  </li>
                  <li>
                    Fees are paid solely for the purpose of posting job advertisements
                    on{" "}
                    <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                      Gulfworker.net
                    </a>
                    .
                  </li>
                </ul>

                <h6>No Guarantee</h6>
                <p>
                  Purchasing a subscription or highlighting a job posting does not
                  guarantee applications, responses, interviews, or successful hiring.
                </p>
                <p>
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  does not guarantee:
                </p>
                <ul>
                  <li>The accuracy, qualifications, or reliability of Jobseekers or Employers.</li>
                  <li>The suitability of any candidate for a position or of any Employer for a Jobseeker.</li>
                </ul>

                <h6>Dispute Limitation</h6>
                <p>
                  In the event of any dispute, complaint, or legal issue — including
                  disputes raised by third parties, advocates, or individuals with
                  malicious intent —{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>
                  ’s maximum liability is strictly limited to the subscription fees
                  actually paid by the concerned Employer or Manpower Agency.
                </p>
                <p>
                  No claims for damages, compensation, loss of business, or any
                  consequential costs shall be entertained.
                </p>

                <h6>Indemnity</h6>
                <p>
                  By using{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>
                  , Employers, Manpower Agencies, and Jobseekers agree to indemnify
                  and hold harmless{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>
                  , its directors, employees, and associates from any and all claims,
                  demands, liabilities, damages, or expenses (including legal fees)
                  arising out of:
                </p>
                <ul>
                  <li>Their use of the platform;</li>
                  <li>Their agreements or interactions with one another; or</li>
                  <li>Any false, misleading, or harmful information they provide.</li>
                </ul>

                <h6>Limitation of Liability</h6>
                <p>
                  Under no circumstances shall{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  be liable for:
                </p>
                <ul>
                  <li>Any indirect, incidental, special, or consequential damages;</li>
                  <li>Loss of profits, opportunities, or reputation;</li>
                  <li>
                    Claims beyond the subscription fees actually received by{" "}
                    <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                      Gulfworker.net
                    </a>
                    .
                  </li>
                </ul>

                <h4>5. No Recruitment Guarantee</h4>
                <p>
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  is a platform only and does not act as a recruitment agency or
                  guarantee job placements.
                </p>
                <p>Uploading a CV or applying for a job does not assure employment.</p>
                <p>
                  Hiring decisions are entirely between Jobseekers, Employers, and
                  Manpower Agencies.
                </p>

                <h4>6. Public Display of Information</h4>
                <ul>
                  <li>
                    By registering, users consent that their contact details (CVs,
                    emails, phone numbers, company/agency info) may be publicly visible.
                  </li>
                  <li>
                    <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                      Gulfworker.net
                    </a>{" "}
                    is not responsible for how third parties use publicly displayed
                    information.
                  </li>
                  <li>Users should only share information they are comfortable making public.</li>
                </ul>

                <h4>7. Intellectual Property</h4>
                <p>
                  All content on{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  (logos, text, graphics, design) is owned by{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  and may not be copied, reproduced, or distributed without prior
                  written consent.
                </p>

                <h4>8. Termination of Accounts</h4>
                <p>
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  reserves the right to suspend or terminate accounts that violate
                  these Terms or engage in fraudulent, unlawful, or misleading
                  activity, without prior notice.
                </p>

                <h4>9. Amendments</h4>
                <p>
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  may update or modify these Terms & Conditions at any time. Updates
                  become effective once published on the Website. Continued use of
                  the Website constitutes acceptance of updated Terms.
                </p>

                <h4>10. Governing Law</h4>
                <p>
                  These Terms shall be governed by and construed in accordance with
                  the laws of [Insert Applicable Jurisdiction, e.g., India / UAE].
                </p>
                <p>
                  Any disputes arising under these Terms shall be subject to the
                  exclusive jurisdiction of the courts in [Mumbai/India].
                </p>

                <h4>11. Contact Us</h4>
                <p>
                  For questions, concerns, or complaints regarding these Terms,
                  please contact: <br />
                  📧 Email:{" "}
                  <a href="mailto:support@gulfworker.net">support@gulfworker.net</a>
                </p>
              </div>
            </>
          )}
        </Container>
      </div>
      <Footer />
    </>
  );
}

export default TermsandConditions;
